import React, { useEffect, useRef, useState } from 'react';
import { whyChooseUsData } from '../data/mock';
import { Award, Package, Truck, Handshake, Wrench, IndianRupee } from 'lucide-react';

const iconMap = {
  Award: Award,
  Package: Package,
  Truck: Truck,
  Handshake: Handshake,
  Wrench: Wrench,
  IndianRupee: IndianRupee
};

const WhyChooseUsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const currentSection = sectionRef.current;
    
    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className={`text-center mb-16 transform transition-all duration-700 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              {whyChooseUsData.title}
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {whyChooseUsData.points.map((point, index) => {
              const IconComponent = iconMap[point.icon];
              return (
                <div
                  key={index}
                  className={`group bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-500 border-2 border-gray-100 hover:border-green-500 transform ${
                    isVisible 
                      ? 'translate-y-0 opacity-100' 
                      : 'translate-y-10 opacity-0'
                  }`}
                  style={{ transitionDelay: `${index * 80 + 200}ms` }}
                >
                  <div className="flex items-center gap-4">
                    <div className="p-3 bg-green-100 rounded-lg group-hover:bg-green-500 transition-colors">
                      <IconComponent className="w-6 h-6 text-green-600 group-hover:text-white transition-colors" />
                    </div>
                    <p className="text-lg font-semibold text-gray-900 group-hover:text-green-600 transition-colors">
                      {point.text}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
